import { $selectedRibbonBar, ribbonBars } from './RibbonBar';
import { useStore } from '@nanostores/react';
import clsx from 'clsx';

function RibbonTab({ label }: { label: keyof typeof ribbonBars }) {
  const selected = useStore($selectedRibbonBar) === label;

  return (
    <span
      className={clsx(
        'relative cursor-pointer p-2',
        'after:absolute after:bottom-0 after:left-1/2 after:h-0.75 after:w-0 after:-translate-x-1/2 after:bg-green-500 after:transition-all',
        selected && 'after:h-1 after:w-[75%] hover:after:w-full',
        !selected && 'after:bg-black/50! hover:after:w-[75%]',
      )}
      onClick={() => $selectedRibbonBar.set(label)}
    >
      {label}
    </span>
  );
}

export function RibbonTabs() {
  return (
    <div className="flex items-center justify-start gap-2">
      {(Object.keys(ribbonBars) as (keyof typeof ribbonBars)[]).map(key => (
        <RibbonTab key={key} label={key} />
      ))}
    </div>
  );
}
